<template>
    <div
        class="bg absolute w-full h-full left-0 bg-contain bg-no-repeat"
        :style="`background-position: top center; background-image: url(${require('assets/images/shapes/shape-7_gray-100.png')}); /* transform: rotateY(180deg); */`"
    ></div>
</template>

<script>
export default {
    name: 'TopLocationBackgroundShape3',
};
</script>

<style scoped></style>
